
export class SelectItemDto {
    public id: any;
    public description: string;
    public optionLabel: string;
}
